/**
 *
 * @param {string} phoneNumber
 * @returns {boolean}
 */
export function validatePhoneNumber(phoneNumber) {
  const regex = /^\(\d{3}\) \d{3}-\d{4}$/
  if (regex.test(phoneNumber)) {
    return true
  }
  return false
}
